import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const ResultAnalysis = () => {
    useEffect(() => {
        document.title = 'Result Analysis -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Academics  </li> 
                 <li>Result Analysis Classes X & XII  </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Result Analysis Classes X & XII  </h1>
                        <h6>Result Analysis 2023-2024</h6>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/ResultAnalysisClassXII.pdf" target="_blank">  Class XII
                            </Link> </div>
                    </div>
                    <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/ResultAnalysisClassX.pdf" target="_blank">  Class X
                            </Link> </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default ResultAnalysis